import { Component } from '@verndale/core';
import { Accordion } from '@verndale/front-end-components';
import { BREAKPOINTS } from '../constants';

class Module extends Component {
  constructor(el) {
    super(el);
  }
  setupDefaults() {
    this.dom = {
      accordions: this.el._$$('.accordion'),
      trigger: this.el._$$('.accordion__item'),
      triggerExpanded: this.el._$$('.accordion__item--expanded')
    };
    this.accordionItemExpanded = 'accordion__item--expanded';
    this.accordionItem = 'accordion__item';
    this.isDesktop = window.matchMedia(
      `(min-width: ${BREAKPOINTS.TABLET_LANDSCAPE}px)`
    ).matches;
    this.initAccordions();
  }

  initAccordions() {
    new Accordion(this.el);
    if (this.el.classList.contains('accordion--first-item-expanded')) {
      this.expandFirstItem();
    }
    if (this.el.classList.contains('accordion--all-desktop-items-expanded'))
      this.expandAllItemsOnDesktop();
  }

  addListeners() {
    this.dom.trigger._on('click', this.handleClick.bind(this));
  }

  expandFirstItem() {
    const item = this.el._$('.accordion__item');
    this.expandItem(item);
  }

  expandAllItemsOnDesktop() {
    if (this.isDesktop) {
      const items = this.el._$$('.accordion__item');
      items.forEach(item => this.expandItem(item));
    }
  }

  expandItem(item) {
    item.classList.add(this.accordionItemExpanded);
    item._$('.accordion__item-trigger').click();
  }

  handleClick(e) {
    if (e.currentTarget.classList.contains(this.accordionItemExpanded)) {
      e.currentTarget.classList.remove(this.accordionItemExpanded);
      e.currentTarget.classList.add(this.accordionItem);
    } else {
      e.currentTarget.classList.remove(this.accordionItem);
      e.currentTarget.classList.add(this.accordionItemExpanded);
    }
  }
}

export default Module;
